import type { FC } from 'react';
import type { Dispatch, SetStateAction } from 'react';
import { SaveTemplateForm } from './SaveTemplateForm';
import { UpdateTemplateForm } from './UpdateTemplateForm';

export type TemplateFormContainerProps = {
    handleCancel: () => void;
    handleSaveTemplate: () => void;
    handleUpdateTemplate: () => void;
    editingTemplateId?: string;
    setEditingTemplateId?: Dispatch<SetStateAction<string | undefined>>;
    isActive: boolean;
};

export const TemplateFormContainer: FC<TemplateFormContainerProps> = (props) => {
    const { editingTemplateId } = props;

    if (!props.isActive) {
        return null;
    }

    if (editingTemplateId) {
        return <UpdateTemplateForm {...props} editingTemplateId={editingTemplateId} />;
    } else {
        return <SaveTemplateForm {...props} />;
    }
};
